/* eslint-disable camelcase */
/* global femcare */

femcare.tracking.product = {
    $productInfo: $('.product-main__info'),

    init: function () {
        let isEcommerce = this.$productInfo.parents('.product-main--shop').length;

        if (this.$productInfo.length) {

            // Regular GA4 Analytics
            // TODO temove after GA4 transition
            this.regularGAReviewsAnalytics();

            // GA4 Analytics
            this.powerReviewsAnalytics();
            this.bazaarVoiceAnalytics();
            this.viewProductAnalytics(this.$productInfo, isEcommerce);
        }
    },

    // Regular GA4 Analytics
    // TODO temove after GA4 transition
    regularGAReviewsAnalytics: function () {
        // attach GA event to reviews (PowerReviews and Bazaar Voice)

        $('#pr-reviewdisplay').on('click', '.pr-snippet-write-review-link', function (e) {
            const isPowerReviewsLoaded = window.POWERREVIEWS;

            if (isPowerReviewsLoaded) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'Review',
                    eventCategory: 'Review',
                    eventAction: 'Presubmit',
                    eventLabel: window.location.href
                });

                e.stopPropagation();
            }
        });

        $('.show-reviews-container').on('click', '.bv-write-review, .bv-first-to-review', function (e) {
            const isBVLoaded = window.$BV;
            if (isBVLoaded) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'Review',
                    eventCategory: 'Review',
                    eventAction: 'Presubmit',
                    eventLabel: window.location.href
                });
                e.stopPropagation();
            }
        })
    },

    // GA4 Analytics
    powerReviewsAnalytics: function () {
        const isPowerReviewsLoaded = window.POWERREVIEWS;

        $('#pr-reviewdisplay').on('click', '.pr-snippet-write-review-link', (e) => {
            if (isPowerReviewsLoaded) {
                this.writeReview('Write a review cta click');
                e.stopPropagation();
            }
        });

        $('#pr-reviewdisplay').on('click', '#pr-war-form .pr-rating-stars label', (e) => {
            if (isPowerReviewsLoaded) {
                this.writeReview('Start to write a review');
                e.stopPropagation();
            }
        });

        $('#pr-reviewdisplay').on('click', '.pr-btn-review', (e) => {
            this.writeReview('Submit a review');
            e.stopPropagation();
        });
    },

    bazaarVoiceAnalytics: function () {
        const isBVLoaded = window.$BV;

        $('.show-reviews-container').on('click', '.bv-write-review, .bv-first-to-review', function (e) {
            if (isBVLoaded) {
                this.writeReview('Write a review cta click');
                e.stopPropagation();
            }
        }.bind(this))

        $('body').on('click', '.bv-form-actions-submit', function (e) {
            if (isBVLoaded) {
                this.writeReview('Submit a review');
                e.stopPropagation();
            }
        }.bind(this));
    },

    /**
     * Tracks clicks on the product cta-panel, but only for shoppable websites
     * @param {string} actionType Action type is type of ga4 review event
     */
    writeReview: function (actionType) {
        const rewiewsGAData = femcare.shared.util.getEntryFromObject(window.gaDataLayer, 'Name', 'ga4_review');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ga4_review',
            ga4_data: {
                action_type: actionType,
                single_item_id: rewiewsGAData[0].Data.single_item_id,
                single_item_name: rewiewsGAData[0].Data.single_item_name,
            }
        });
    },

    // E-commerce events for products

    /**
     * Tracks clicks on the product cta-panel, but only for shoppable websites
     * @param {jQuery} $selectedProduct
     * @param {boolean} isEcommerce
     */
    selectProductAnalytics: function ($selectedProduct, isEcommerce) {
        const eventId = $selectedProduct[0].dataset.gaEventId;
        const eventType = $selectedProduct[0].dataset.gaEventType;

        if (isEcommerce) {
            const itemIndex = $selectedProduct.parent().index() + 1;
            const gaObjArray = femcare.shared.util.getEntryFromObject(window.gaDataLayer, 'Id', eventId);

            if (gaObjArray && gaObjArray.length > 0) {
                const gaObj = gaObjArray[0];
                if (gaObj && gaObj.Data) {
                    gaObj.Data.index = itemIndex;
                    femcare.tracking.gaTracking.addAnalytics(eventId, eventType, true);
                }
            }
        } else {
            femcare.tracking.gaTracking.addAnalytics(eventId, eventType, false);
        }
    },

    /**
     * Tracks load of PDP page
     * @param {jQuery} $product
     * @param {boolean} isEcommerce
    */
    viewProductAnalytics: function ($product, isEcommerce) {
        const eventId = $product[0].dataset.gaEventId;
        const eventType = $product[0].dataset.gaEventType;

        femcare.tracking.gaTracking.addAnalytics(eventId, eventType, isEcommerce);
        if (isEcommerce) {
            const eventIndex = window.dataLayer.length;
            window.dataLayer[eventIndex - 1].ecommerce.items[0].index = 0;
        }
    },

    /**
    * Tracks change of product variant on PDP pages, but only for shoppable websites
    * @param {obj} productData
   */
    eccomViewProductVariantAnalytics: function (productData) {
        if (!productData) {
            return;
        }
        const adaptedProductData = {
            items: []
        };
        adaptedProductData.items[0] = productData
        const productVariantAnalytics = this.itemsData(adaptedProductData);

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'view_item',
            ecommerce: {
                items: productVariantAnalytics
            }
        });

        const eventIndex = window.dataLayer.length;
        window.dataLayer[eventIndex - 1].ecommerce.items[0].index = 0;
    },

    /**
     * Triggers on adding product to cart
     * @param {obj} data
     * @param {number} count
     * @param {boolean} isQuickBuy
     */
    ecommAddProductToCart: function (data, count, isQuickBuy) {
        if (!data) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: 'add_to_cart',
            quick_buy: isQuickBuy,
            ecommerce: {
                items: [{
                    item_id: data.productId,
                    item_name: data.name,
                    currency: data.priceInformation?.currency?.code,
                    discount: data.priceInformation?.discount,
                    index: 0,
                    item_list_name: data.category,
                    item_variant: data.productSkuName,
                    price: data.priceInformation?.priceWithoutDiscountNoFormat,
                    quantity: count
                }]
            }
        });
    },

    /**
     * Triggers on adding product to cart
     * @param {obj} data
     * @param {number} count
     */
    ecommRemoveProductFromCart: function (data, count) {
        if (!data) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
        window.dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
                items: [{
                    item_id: data.productId,
                    item_name: data.name,
                    currency: data.priceInformation?.currency?.code,
                    item_variant: data.productSkuName,
                    price: data.priceInformation?.priceWithoutDiscountNoFormat,
                    quantity: Math.abs(count)
                }]
            }
        });
    },

    /**
     * Triggers on view cart event
     * @param {boolean} cartHasProducts
     * @param {object} cartData
     */
    viewCartAnalytics: function (cartHasProducts, cartData) {
        if (cartHasProducts && cartData && cartData.items && cartData.items.length > 0) {
            const totalPrice = cartData.totalizers[0].valueNoFormat;
            const currencyCode = cartData.items[0].priceInformation.currency.code;
            const cartItemsAnalytis = this.itemsData(cartData);

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'view_cart',
                ecommerce: {
                    currency: currencyCode,
                    value: totalPrice, // The combined price of all existing items
                    items: cartItemsAnalytis,
                }
            });
        }
    },

    /**
     * Triggers on click on Finalize shopping, on chart and cart-notification modals
     * @param {object} cartData
     */
    beginCheckoutAnalytics: function (cartData) {
        if (!cartData || !cartData.items) {
            return;
        }
        const cartItemsAnalytis = this.itemsData(cartData);
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
                items: cartItemsAnalytis
            }
        });
    },


    /**
     * Makes object with appropriate data for ga4 DataLayer
     * @param {object} cartData
     * @returns {object} cartItemsAnalytics
     */
    itemsData: function (cartData) {
        const cartItemsAnalytics = [];
        const cartItems = cartData.items;

        for (let cartIndex = 0; cartIndex < cartItems.length; cartIndex++) {
            const product = cartItems[cartIndex];

            const item = {
                item_id: product.productId,
                item_name: product.name,
                currency: product.priceInformation.currency.code,
                discount: product.priceInformation.discount,
                item_variant: product.productSkuName,
                price: product.priceInformation.priceWithoutDiscountNoFormat,
                quantity: product.productQuantity.initial
            }

            cartItemsAnalytics.push(item);
        }

        return cartItemsAnalytics;
    }
}